// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6af9b769","462":"151ec624","610":"72a8d6b7","701":"94354b81"}[chunkId] + ".chunk.js";
};